<template>
  <div class="form">
    <div class="columns is-centered">
      <section class="content-box column is-three-quarters">
        <template v-if="this.success !== null">
          <template v-if="this.success">
            <h1>{{ form.name }}</h1>
            <img v-if="form.logo_url" :src="form.logo_url" style="margin-top: 15px; max-width: 100%; max-height: 300px;"/>
            <p>{{ form.terms }}</p>
            <form class="theform">
              <div class="field">
                <label class="label">Antal aktier<span class="required">*</span></label>
                <div class="control">
                  <input class="input" type="number" v-model="formdata.numshares" placeholder="">
                </div>
              </div>
              <div class="field">
                <label class="label">Person- eller organisationsnummer<span class="required">*</span></label>
                <div class="control">
                  <input class="input" type="text" v-model="formdata.uid"  placeholder="">
                </div>
              </div>
              <div v-if="false" class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">Depånummer<span class="required">*</span></label>
                    <div class="control">
                      <input class="input" type="text" v-model="formdata.custody_account_nr" placeholder="">
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">Depåinstitut<span class="required">*</span></label>
                    <div class="control">
                      <input class="input" type="text" v-model="formdata.bank_or_custodee"  placeholder="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">Förnamn<span class="required">*</span></label>
                    <div class="control">
                      <input class="input" type="text" v-model="formdata.firstname" placeholder="">
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">Efternamn<span class="required">*</span></label>
                    <div class="control">
                      <input class="input" type="text" v-model="formdata.lastname" placeholder="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Företag (Om du tecknar som företag)</label>
                <div class="control">
                  <input class="input" type="text" v-model="formdata.orgname"  placeholder="">
                </div>
              </div>
              <div class="field">
                <label class="label">Adress<span class="required">*</span></label>
                <div class="control">
                  <input class="input" type="text" v-model="formdata.address1"  placeholder="">
                </div>
              </div>
              <div class="field">
                <label class="label">Adress, forts.</label>
                <div class="control">
                  <input class="input" type="text" v-model="formdata.address2"  placeholder="">
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">Postnr<span class="required">*</span></label>
                    <div class="control">
                      <input class="input" type="text" v-model="formdata.zip"  placeholder="">
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">Ort<span class="required">*</span></label>
                    <div class="control">
                      <input class="input" type="text" v-model="formdata.city"  placeholder="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label">E-post<span class="required">*</span></label>
                <div class="control">
                  <input class="input" type="email" v-model="formdata.email"  placeholder="">
                </div>
              </div>
              <div class="field">
                <label class="label">Telefon, dagtid</label>
                <div class="control">
                  <input class="input" type="text" v-model="formdata.phone"  placeholder="">
                </div>
              </div>
              <div class="field">
                <label class="label">Mobiltelefon</label>
                <div class="control">
                  <input class="input" type="text" v-model="formdata.mobile"  placeholder="">
                </div>
              </div>
              <a class="button is-primary" @click="sign()" style="height: 50px; width: 100%; margin-top: 15px;">
                <font-awesome-icon class="icon question" icon="id-card" />
                Signera med BankId
              </a>
            </form>
          </template>
          <template v-if="!this.success">
            Kunde inte läsa in blankett.
          </template>
        </template>
      </section>
    </div>
  </div>
</template>

<style scoped>
  .required { color: #ff0000; }
  .field { margin-bottom: 0px; }
  .theform .columns { padding: 0px; margin: 0px; }
  .theform .column { padding: 0px !important; }
  label { margin: 0px !important; }
</style>

<script>

const isValidPersonUidFn = function(nin) {
  if (!(/^[0-9]{6}[\-\+]?[0-9]{4}?$/.test(nin) ||
        /^[0-9]{8}[\-\+]?[0-9]{4}?$/.test(nin))) { return false; }
  nin = nin.replace(/\D/g,'');
  let cs;
  if (nin.length === 12) {
    cs = [ nin.substr(0, 2) ];
    nin = nin.substr(2);
  } else { cs = [ 19, 20 ]; }
  let sum = '2121212121'.split('')
    .reduce((s,c,i) => s + (nin[i] * c - 1) % 9 + 1, 0);
  if (sum % 10 !== 0) { return false; }
  let [ y, m, d ] = nin.split(/(.{2})/).filter(c => c);
  return cs.some(p => {
    let date = new Date(`${p}${y}-${m}-${d}`);
    return Boolean(+date) && date.getDate() == d;
  });
};

const isValidOrgUidFn = function(nin) {
  if (!/^[0-9]{6}-?[0-9]{4}?$/.test(nin)) { return false; }
  nin = nin.replace(/\D/g,'');
  let sum = '2121212121'.split('')
    .reduce((s,c,i) => s + (nin[i] * c - 1) % 9 + 1, 0);
  if (sum % 10 !== 0) { return false; }
  let [ _, m ] = nin.split(/(.{2})/).filter(c => c);
  return m >= 20;
};

import axios from 'axios';
const apiUrl = 'https://shares-subscription-forms-api.reguity.com';
export default {
  name: 'form',
  methods: {
    getValidationErrors: function () {
      let errors = [];
      let isValidPersonUid = false;
      let isValidOrgUid = false;
      if (this.formdata.numshares <= 0) { errors.push('Antalet aktier måste vara fler än 0.'); }
      if (this.formdata.uid <= 0) {
        errors.push('Person- eller organisationsnummer behöver fyllas i.');
      } else {
        isValidPersonUid = isValidPersonUidFn(this.formdata.uid);
        isValidOrgUid = isValidOrgUidFn(this.formdata.uid);
        if (!isValidPersonUid && !isValidOrgUid) {
          errors.push('Person- eller organisationsnummer måste vara giltigt');
        }
      }
      //if (!this.formdata.custody_account_nr) { errors.push('Depånummer måste fyllas i'); }
      //if (!this.formdata.bank_or_custodee) { errors.push('Depåinstitut måste fyllas i'); }
      if (!this.formdata.firstname) {
        if (isValidOrgUid) { errors.push('Förnamn till kontaktperson för företaget måste fyllas i'); }
        else { errors.push('Ditt förnamn måste fyllas i'); }
      }
      if (!this.formdata.lastname) {
        if (isValidOrgUid) { errors.push('Efternamn till kontaktperson för företaget måste fyllas i'); }
        else { errors.push('Ditt efternamn måste fyllas i'); }
      }
      if (isValidOrgUid && !this.formdata.orgname) { errors.push('Företagets namn måste fyllas i'); }
      if (!this.formdata.address1) { errors.push('Adress måste fyllas i'); }
      if (!this.formdata.zip) { errors.push('Postnummer måste fyllas i'); }
      if (!this.formdata.city) { errors.push('Postort måste fyllas i'); }
      if (!this.formdata.email) { errors.push('Email måste fyllas i'); }
      if (!(this.formdata.phone || this.formdata.mobile)) { errors.push('Minst ett telefonnummer måste fyllas i'); }
      return errors;
    },
    sign: async function () {
      let errors = this.getValidationErrors();
      if (errors.length > 0) { alert(errors.join("\n")); return; }
      console.warn('ok. Data data');
      try {
        let { data } = await axios.post(`${apiUrl}/applications`, this.formdata);
        console.warn('ok, data', data);
        if (data.sign_url) {
          if (this.formdata.form_id == 'ENTREPRENORSKAPITAL-KYNETT-AB') {
            await new Promise(r => {
              axios
                .get(`https://ekapaif.se/hubspot/hs_respons.php?your-email=${this.formdata.email}&token=trEQ785;pouYU`)
                .then(_ => {
                  r();
                })
                .catch(error => {
                  console.log(error.response)
                  r();
                });
            });
          }
          window.location.href = data.sign_url;
        }
      } catch(err) {
        alert('BankId-signering misslyckades. Formuläret har inte skickats.');
        this.success = false;
      }
    }
  },
  data: () => ({
    success: null,
    form: null,
    formdata: {
      form_id: null,
      numshares: 0,
      uid: '',
      custody_account_nr: '',
      bank_or_custodee: '',
      firstname: '',
      lastname: '',
      orgname: '',
      address1: '',
      address2: '',
      zip: '',
      city: '',
      email: '',
      phone: '',
      mobile: ''
    }
  }),
  mounted: async function() {
    let id = this.$route.params.id;
    this.formdata.form_id = id;
    try {
      let { data } = await axios.get(`${apiUrl}/forms/${id}`);
      this.form = data;
      this.success = true;
    } catch (err) {console.warn(err);
      this.success = false;
    }

  },
  components: {
    //HelloWorld
  }
}
</script>
